//region header */
//--------------------------------------------------------------------------------------------------
//
//  Description: Control used to display a circular progress indicator.
//
//  Copyright:    © 025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.6.0
//    001   22.07.25 Sean Flook       IMANN-1855 Initial version.
//    002   22.07.25 Sean Flook       IMANN-1855 Added the mapProgress parameter.
//endregion Version 1.0.6.0
//
//--------------------------------------------------------------------------------------------------
//endregion header */

import React from "react";
import PropTypes from "prop-types";

import { Backdrop, CircularProgress, Box, Typography } from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";

import { adsRed, adsGreenA, adsBlueA } from "../utils/ADSColours";

ADSCircularProgress.propTypes = {
  display: PropTypes.bool,
  message: PropTypes.string,
  progress: PropTypes.number,
  failedCount: PropTypes.number,
  mapProgress: PropTypes.bool,
  displayPercentage: PropTypes.bool,
  size: PropTypes.number,
};

function ADSCircularProgress({
  display = false,
  message = "",
  progress = 0,
  failedCount = 0,
  mapProgress = false,
  displayPercentage = false,
  size = 60,
}) {
  if (mapProgress) {
    return (
      <CircularProgress
        sx={{
          position: "absolute",
          top: "50%",
          left: "60%",
          color: failedCount > 0 ? adsRed : progress === 0 ? adsBlueA : adsGreenA,
        }}
        size={size}
        variant={progress === 0 ? "indeterminate" : "determinate"}
        value={progress}
      />
    );
  } else {
    return (
      <Backdrop open={display}>
        {message && (
          <Typography
            variant="h4"
            component="div"
            sx={{
              top: -120,
              left: 0,
              bottom: 0,
              right: 0,
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {message}
          </Typography>
        )}
        <CircularProgress
          sx={{ color: failedCount > 0 ? adsRed : progress === 0 ? adsBlueA : adsGreenA }}
          size={size}
          variant={progress === 0 ? "indeterminate" : "determinate"}
          value={progress}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HomeIcon sx={{ color: `${failedCount > 0 ? adsRed : progress === 0 ? adsBlueA : adsGreenA}` }} />
          {displayPercentage && (
            <Typography
              variant="caption"
              component="div"
              sx={{ color: `${failedCount > 0 ? adsRed : progress === 0 ? adsBlueA : adsGreenA}` }}
            >{`${progress}%`}</Typography>
          )}
        </Box>
      </Backdrop>
    );
  }
}

export default ADSCircularProgress;
